import React from "react";
import { motion } from "framer-motion";

export default function AboutUsNatural({ className }) {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@600;700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <section className={"w-full bg-[#F5F5F5] text-[#000] antialiased py-12 sm:py-16 md:py-20 px-4 sm:px-8 lg:px-12 flex flex-col items-center select-none overflow-hidden " + (className || "")}>
        <div className="w-full max-w-[1520px] flex flex-col gap-8 md:gap-10">

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="w-full flex flex-col gap-3 sm:gap-4"
          >
            <h2
              className="tracking-tighter select-none block"
              style={{
                fontFamily: '"Big Shoulders Display", sans-serif',
                fontSize: "clamp(56px, 13.5vw, 205.291px)",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "1",
                letterSpacing: "-4.106px",
                margin: 0,
              }}
            >
              <span style={{ color: "#000000" }}>Why </span>
              <span style={{ color: "#D2D2D2" }}>Choose </span>
              <span style={{ color: "#000000" }}>Us</span>
            </h2>

            <p
              style={{
                color: "#353535",
                fontFamily: "Inter, sans-serif",
                fontSize: "clamp(15px, 1.3vw, 20px)",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "1.4",
                maxWidth: "850px",
                margin: 0,
              }}
            >
              We're committed to helping you achieve radiant, healthy skin. Our expert team offers personalized treatments.
            </p>
          </motion.div>

          <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end pt-0 sm:pt-2">

            <motion.div
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="lg:col-span-5 flex flex-col justify-end items-start gap-5 sm:gap-6 self-end pb-0"
            >
              <p
                style={{
                  color: "#353535",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "clamp(16px, 1.25vw, 20px)",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.45",
                  maxWidth: "480px",
                  margin: 0,
                }}
              >
                We're committed to helping you achieve radiant, healthy skin. Our expert team offers personalized treatments.
              </p>

              <button
                className="hover:scale-105 active:scale-95 transition-all cursor-pointer shadow-sm"
                style={{
                  display: "inline-flex",
                  padding: "12px 12px 12px 18px",
                  alignItems: "center",
                  gap: "9px",
                  borderRadius: "12px",
                  background: "#B9F33F",
                  border: "none",
                }}
              >
                <span
                  style={{
                    color: "#242424",
                    textAlign: "center",
                    fontFamily: '"Big Shoulders Display", sans-serif',
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "18px",
                    textTransform: "uppercase",
                  }}
                >
                  EXPLORE MORE
                </span>

                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#242424"
                  strokeWidth={2.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7 17L17 7" />
                  <path d="M7 7h10v10" />
                </svg>
              </button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
              className="lg:col-span-7 w-full flex justify-end"
            >
              <div
                className="w-full bg-[#D9D9D9] rounded-[20px] sm:rounded-[28px] md:rounded-[32px] overflow-hidden shadow-md"
                style={{
                  aspectRatio: "7/4.5",
                  minHeight: "280px",
                  maxHeight: "520px",
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1556228578-8c89e6adf883?auto=format&fit=crop&w=1400&q=80"
                  alt="Organic skincare treatment"
                  className="w-full h-full object-cover rounded-[20px] sm:rounded-[28px] md:rounded-[32px]"
                  referrerPolicy="no-referrer"
                />
              </div>
            </motion.div>

          </div>

        </div>
      </section>
    </>
  );
}